import { permitConstants } from '../../../../../constants/permit.constants';

export const getOptionsByDateTypeFilter = (valueType) => {
  return [
    {
      id: 1,
      name: 'Дата создания',
      value: 1,
      key: 1,
      content: 'Дата создания',
    },
    {
      id: 2,
      name: 'Дата аннулирования',
      value: 2,
      key: 2,
      content: 'Дата аннулирования',
    },
    ...(valueType === permitConstants.TEMPORARY_PASS
      ? [
          {
            id: 3,
            value: 3,
            name: 'Дата действия временного пропуска',
            key: 3,
            content: 'Дата действия временного пропуска',
          },
        ]
      : []),
  ];
};
